// Global Instructions Rule Applied!
// Content for a select field's help "?" (InputManager `labelTooltip`): an
// optional lead sentence, then every option with its cfg `description` and,
// where the lookup carries one, its worked `example` on a line of its own.
// The options and their wording come from globalConfigs — never hardcoded —
// so an admin's edit to a cfg description shows up here as it is.

import React from 'react'

export interface LookupHelpEntry {
  label: string
  description?: string | null
  // a worked example in plain words (cfg `example`), shown under the description
  example?: string | null
}

export function lookupOptionsHelp(lead: string | null, entries: LookupHelpEntry[]): React.ReactNode {
  const described = entries.filter((e) => e.description)
  if (!lead && described.length === 0) return undefined
  return (
    <div>
      {lead ? <div>{lead}</div> : null}
      {described.map((e) => (
        <div key={e.label} className='mt-1'>
          <strong>{e.label}</strong>: {e.description}
          {e.example ? <div className='mt-1 italic'>Example: {e.example}</div> : null}
        </div>
      ))}
    </div>
  )
}
